export default "__VITE_ASSET__RZ9Zq7iF__"